import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopPaypal = dynamic(() => import("../../components/payment-partners/paypal/DesktopPaypal"), {
    loading: () => <Loading />,
}
);

const MobilePaypal = dynamic(() => import("../../components/payment-partners/paypal/MobilePaypal"), {
    loading: () => <Loading />,
}
);

const payuIntegration = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Complete PayPal Integration With QueueBuster POS Software</title>
                <meta name="description" content="Accept payments & manage lines with ease! Pair Paypal POS hardware with QueueBuster POS software." />
                <link rel="canonical" href="https://queuebuster.co/pos-payment-partners/paypal" />
                <link rel="alternate" href="https://queuebuster.co/pos-payment-partners/paypal" hrefLang="en-us" />
                <meta property="og:title" content="Complete PayPal Integration With QueueBuster POS Software" />
                <meta property="og:description" content="Accept payments & manage lines with ease! Pair Paypal POS hardware with QueueBuster POS software." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/paypal.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-payment-partners/paypal" />
            </Head>
            {mobileView ? <MobilePaypal /> : <DesktopPaypal />}
        </>
    )
}

export default payuIntegration